import * as consts from './base/consts'
import { UTILS } from '../utils'
import { MOMENT_TIME } from '../momenttime'
import format, { FORMAT } from './core/format'
import paipan, { PAIPAN } from './core/paipan'
/**
 * 分管各个模块的数据管理类
 */
import { BASE_DATA_MANAGER } from './manager/basedatamng'
import { SETTING_DATA_MANAGER } from './manager/settingdatamng'
import { INFORM_DATA_MANAGER } from './manager/informdatamng'
import { COLLATE_DATA_MANAGER } from './manager/collatedatamng'
import { DIAGRAM_DATA_MANAGER } from './manager/diagramdatamng'
import { RECORD_DATA_MANAGER } from './manager/recorddatamng'
import { GROUP_DATA_MANAGER } from './manager/groupdatamng'
import { LABEL_DATA_MANAGER } from './manager/labeldatamng'
import { FATE_DATA_MANAGER } from './manager/fatedatamng'
import { SEARCH_DATA_MANAGER } from './manager/searchdatamng'
import { COMMENT_DATA_MANAGER } from './manager/commentdatamng'
import { OTHER_COMMENT_DATA_MANAGER } from './manager/othercommentdatamng'
import { DISCUSS_DATA_MANAGER } from './manager/discussdatamng'
import { DONATE_DATA_MANAGER } from './manager/donatedatamng'
import { REPORT_DATA_MANAGER } from './manager/reportdatamng'
import { FAMOUS_PEDIA_DATA_MANAGER } from './manager/famouspediadatamng'
import { CALENDAR_DATA_MANAGER } from './manager/calendardatamng'
import { CONTRAST_DATA_MANAGER } from './manager/contrastdatamng'
import { COURSE_DATA_MANAGER } from './manager/coursedatamng'
import { STRONG_DATA_MANAGER } from './manager/strongdatamng'
import { MARRIAGE_DATA_MANAGER } from './manager/marriagedatamng'
/**
 * 处理前端展示数据
 * 定义后端数据转换成前端数据结构的方法
 */
var DATA = {
    /**
     * 获取排盘的分享文字内容
     * @param {是否匿名分享} hideName 
     * @param {命盘数据} data 
     */
    getSharedTextByData(type, hideName, data) {
        var text = '';
        var sexStr = data.sex == 0 ? '乾男：' : '坤女：';
        var nameList = consts.CONST_SHARE_NAME_LIST;
        var newName = nameList[Math.floor(Math.random() * nameList.length)];
        var name = hideName ? newName : data.f_name;
        text += sexStr;
        text += name;
        if(type == 'wechat') { text += '.\n'; }
        if(type == 'qq') { text += '.\n'; }
        // 第二行:八字
        var arr = FORMAT.getEightWordArrByData(data.unknown, data);
        for (var i = 0; i < arr.length; i++) {
            text += arr[i][0].text;
            text += arr[i][1].text;
            text += ' ';
        }
        return text;
    },
    /**
     * 获取自己的批盘的分享文字内容
     * @param {当前用户的信息} userInfo 
     * @param {命盘数据} data 
     */
    getPipanSharedTextByData(type, hideName, userInfo, data) {
        // console.log('getPipanSharedTextByData------', userInfo, data)
        var text = '';
        var sexStr = data.sex == 0 ? '乾男：' : '坤女：';
        var pipanStr = userInfo && userInfo.info ? userInfo.info.nickname : '某某某';
            pipanStr = pipanStr ? pipanStr.slice(0, 10) : '某某某';
        // text += (pipanStr + '批盘：');
        text += data.f_name && !hideName ? data.f_name.slice(0, 10) : '匿名';
        if(type == 'wechat') { text += '.\n'; }
        if(type == 'qq') { text += '.\n'; }
        text += sexStr;
        // 八字
        var arr = FORMAT.getEightWordArrByData(data.unknown, data);
        for (var i = 0; i < arr.length; i++) {
            text += arr[i][0].text;
            text += arr[i][1].text;
            text += ' ';
        }
        return text;
    },
    /**
     * 获取他人的批盘的分享文字内容
     * @param {他人批盘的标题} shareTitle 
     * @param {命盘数据} data 
     */
    getOtherPipanShareTextByData(type, hideName, shareTitle, data) {
        // console.log('getOtherPipanShareTextByData-----', shareTitle, data)
        var text = '';
        var sexStr = data.sex == 0 ? '乾男：' : '坤女：';
        // text += shareTitle;
        text += data.f_name && !hideName ? data.f_name.slice(0, 10) : '匿名';
        if(type == 'wechat') { text += '.\n'; }
        if(type == 'qq') { text += '.\n'; }
        text += sexStr;
        var arr = FORMAT.getEightWordArrByData(data.unknown, data);
        for (var i = 0; i < arr.length; i++) {
            text += arr[i][0].text;
            text += arr[i][1].text;
            text += ' ';
        }
        return text;
    },

    /**
     * 获取论盘的分享文字内容
     * @param {论盘的标题} shareTitle 
     * @param {命盘数据} data 
     */
    getLunPanShareTextByData(type, shareTitle, data) {
        var text = '';
        var sexStr = data.sex == 0 ? '乾男：' : '坤女：';
        shareTitle = shareTitle;
        text += shareTitle;
        if(type == 'wechat') { text += '.\n'; }
        if(type == 'qq') { text += '.\n'; }
        text += sexStr;
        var arr = FORMAT.getEightWordArrByData(data.unknown, data);
        for (var i = 0; i < arr.length; i++) {
            text += arr[i][0].text;
            text += arr[i][1].text;
            text += ' ';
        }
        return text;
    },
    /**
     * 获取百科的分享文字内容
     * @param {八字数据} data 
     */
    getFamousPediaShareTextByData(type, data) {
        var text = '名人八字百科:';
            text += data.f_name;
        if(type == 'wechat') { text += '.\n'; }
        if(type == 'qq') { text += '.\n'; }
        var arr = FORMAT.getEightWordArrByData(data.unknown, data);
        for (var i = 0; i < arr.length; i++) {
            text += arr[i][0].text;
            text += arr[i][1].text;
            text += ' ';
        }
        return text;
    },

    /**
     * getTimeInfoByInputData
     * @param {*} params 
     * @returns 
     */
     getTimeInfoByInputData(params, type) {
        var y, m, d, h, mi, r;
        y = parseInt(params.year);
        m = parseInt(params.month);
        d = parseInt(params.day);
        h = parseInt(params.hour);
        mi = parseInt(params.minute);
        r = params.run ? 1 : 0;

        // 农历要转换成公历
        if (params.isLunar) {
            var temp = PAIPAN.Lunar2Solar(y, m, d, r)
            y = temp.y;
            m = temp.m;
            d = temp.d;
        }
        // 拼凑字符串
        var dateStr = UTILS.formatYearNum(y) + '-';
        dateStr = dateStr + UTILS.getTimeStrByInt(m) + '-';
        dateStr = dateStr + UTILS.getTimeStrByInt(d) + ' ';
        if (!params.unknownTime) {
            dateStr = dateStr + UTILS.getTimeStrByInt(h) + ':';
            dateStr = dateStr + UTILS.getTimeStrByInt(mi) + ':00';
        }else{
            dateStr = dateStr + '00:00:00'
        }
        // var time = moment(dateStr).unix();
        var time = MOMENT_TIME.getUnixTimeByTimeStr(dateStr);

        // console.log('getTimeInfoByInputData::::', dateStr, time);
        if(type == 'datestr') {
            return dateStr;
        }else if(type == 'datestrtime'){
            dateStr = y+'年';
            dateStr += UTILS.getTimeStrByInt(m)+'月';
            dateStr += UTILS.getTimeStrByInt(d)+'日 ';
            dateStr += UTILS.getTimeStrByInt(h)+':';
            dateStr += UTILS.getTimeStrByInt(mi);
            return [dateStr, time];
        }
    }
}


export {
    DATA,
    BASE_DATA_MANAGER,
    SETTING_DATA_MANAGER,
    INFORM_DATA_MANAGER,
    COLLATE_DATA_MANAGER,
    DIAGRAM_DATA_MANAGER,
    RECORD_DATA_MANAGER,
    GROUP_DATA_MANAGER,
    LABEL_DATA_MANAGER,
    FATE_DATA_MANAGER,
    SEARCH_DATA_MANAGER,
    COMMENT_DATA_MANAGER,
    OTHER_COMMENT_DATA_MANAGER,
    DISCUSS_DATA_MANAGER,
    DONATE_DATA_MANAGER,
    REPORT_DATA_MANAGER,
    FAMOUS_PEDIA_DATA_MANAGER,
    CALENDAR_DATA_MANAGER,
    CONTRAST_DATA_MANAGER,
    COURSE_DATA_MANAGER,
    STRONG_DATA_MANAGER,
    MARRIAGE_DATA_MANAGER
}